export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-9.png?625fa35a159684d9465562ee5f57b77f";